import { getProject } from '../../common/services/project';
import { IPhase } from './typings';

export const getPhaseHref = (phase: IPhase): string =>
  `#${getProject().url}/phases/${phase.id}`;
